import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "..";

const requestBaseQuery = baseQuery("product_type", "*");

export const productTypeApi = createApi({
  reducerPath: "productType",
  baseQuery: requestBaseQuery,
  tagTypes: ["product_type"],
  endpoints: (builder) => ({
    getAllProductType: builder.query({
      query: () => ({
        type: "GET",
        order: [
          { column: "created_at", ascending: true },
        ],
      }),
      providesTags: [{ type: "product_type", id: "LIST" }],
      keepUnusedDataFor: 3600,
    }),
  }),
});

export const { useGetAllProductTypeQuery } = productTypeApi;
